import React, { useEffect, useState } from 'react';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { resolveUnitAvailability } from "../admin/config.js";

const FetchAvailableRooms = ({ propertyId, unitId }) => {
  const [availability, setAvailability] = useState(null);

  useEffect(() => {
    const fetchRoomAvailability = async () => {
      const db = getFirestore(); // Get Firestore instance

      const roomRef = doc(db, `Properties/${propertyId}/Units/${unitId}`);

      try {
        const docSnap = await getDoc(roomRef); // Fetch the document for the room

        if (docSnap.exists()) {
          setAvailability(resolveUnitAvailability(docSnap.data()));
        } else {
          console.log("No such room!");
          setAvailability(resolveUnitAvailability({ Available: false }));
        }
      } catch (error) {
        console.error("Error fetching room: ", error);
      }
    };

    fetchRoomAvailability(); // Run the async function
  }, [propertyId, unitId]); // Run the effect whenever the title or room changes

  const statusText = availability === null ? "Loading..." : availability.statusText;
  const statusClass =
    availability === null
      ? "is-loading"
      : availability.available
        ? "is-available"
        : availability.statusClass === "scheduled"
          ? "is-scheduled"
          : "is-unavailable";

  return (
    <div className={`availability-status ${statusClass}`}>
      <h5 className="availability-status__label">{statusText}</h5>
    </div>
  );
};

export default FetchAvailableRooms;
